export const SupportActions = {
    GetReport: 'GetReport',
    Report: 'Report',
    ResyncUser: 'ResyncUser',
    IsReportLoading: 'IsReportLoading',
    IsResyncUserLoading: 'IsResyncUserLoading',
};